import PropTypes from 'prop-types';
import { BsCheckLg } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Panel from '#globalComponents/Overlay/Panel';
import { FULLSERVICE_BOOKING_URL } from '#settingsFeature/constants/bookingLinks';

import CancelAnywayButton from '../components/CancelAnywayButton';

const FULLSERVICE_COPY = {
	eyebrow: 'Unser Vorschlag',
	title: 'Keine Zeit? Wir übernehmen das für Sie.',
	body: 'Mit unserem Fullservice kümmern wir uns um Einrichtung, Lead-Recherche und den Versand Ihrer Kampagnen – Sie erhalten nur noch die Antworten. Umfang und Kosten besprechen wir in einem kurzen Gespräch.',
	bullets: [
		'Einrichtung und Zielgruppen-Setup durch uns',
		'Laufende Lead-Recherche',
		'Versand und Nachfassen Ihrer Kampagnen',
	],
};

const CALL_COPY = {
	missing_features: {
		eyebrow: 'Unser Vorschlag',
		title: 'Lassen Sie uns kurz darüber sprechen',
		body: 'Vielleicht gibt es die Funktion schon oder sie steht kurz bevor. In einem kurzen Gespräch zeigen wir Ihnen, was möglich ist, und nehmen Ihren Wunsch direkt in unsere Planung auf.',
		bullets: [],
	},
	technical_issues: {
		eyebrow: 'Unser Vorschlag',
		title: 'Das lösen wir gemeinsam',
		body: 'Technische Probleme lösen wir in der Regel schnell. Buchen Sie ein kurzes Gespräch, dann schauen wir uns das zusammen an.',
		bullets: [],
	},
};

function resolveCopy(offerType, reason) {
	if (offerType === 'fullservice') return FULLSERVICE_COPY;
	return CALL_COPY[reason] ?? CALL_COPY.missing_features;
}

export default function OfferStep({ offerType, reason, onCancelAnyway, onBack, onClose }) {
	const copy = resolveCopy(offerType, reason);

	return (
		<>
			<Panel.Header subtitle={copy.eyebrow} onClose={onClose}>
				{copy.title}
			</Panel.Header>

			<Panel.Body>
				<div className="space-y-5">
					<p className="text-sm text-text">{copy.body}</p>

					{copy.bullets.length > 0 && (
						<ul className="space-y-2">
							{copy.bullets.map((bullet) => (
								<li key={bullet} className="flex items-start gap-2 text-sm text-text">
									<BsCheckLg className="mt-0.5 h-4 w-4 shrink-0 text-success-700" />
									<span>{bullet}</span>
								</li>
							))}
						</ul>
					)}

					<div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
						<Button variant="solid" size="md" fullWidth href={FULLSERVICE_BOOKING_URL} target="_blank">
							Gespräch buchen
						</Button>
						<CancelAnywayButton onClick={onCancelAnyway} />
					</div>

					<p className="text-xs text-bgBase-800">
						Termin gebucht? Dann können Sie dieses Fenster einfach schließen – Ihr Abonnement läuft
						unverändert weiter.
					</p>
				</div>
			</Panel.Body>

			{onBack && (
				<Panel.Footer>
					<Button variant="outline" size="sm" onClick={onBack}>
						Zurück
					</Button>
				</Panel.Footer>
			)}
		</>
	);
}

OfferStep.propTypes = {
	offerType: PropTypes.oneOf(['fullservice', 'call']).isRequired,
	reason: PropTypes.string.isRequired,
	onCancelAnyway: PropTypes.func.isRequired,
	onBack: PropTypes.func,
	onClose: PropTypes.func,
};
